<template>
  <div div class="coverage-calendar">
    <div v-show="initializingCalendar && serviceLoading" class="calendar-loader">
      <i class="fa fa-spinner fa-spin"></i>
      <div class="title">Initializing Calendar...</div>
    </div>

    <!-- <div class="calendar-days" v-show="!initializingCalendar && !serviceLoading">
      <div v-for="(value, prop) in months" class="op-calendar">
        <div class="op-calendar-title">{{ prop }}</div>
        <div class="op-calendar-days">
          <div v-bind:class="{ 'op-calendar-day': true, 'no-border': day === null }" v-for="day in value.days" @click="showCalendarInfo(day)">
            <div v-if="day !== null">
              <div class="op-icon">
                <i class="fa fa-check-circle fa-lg" v-show="day.availableRsvp.length <= 0"></i>
                <i class="fa fa-exclamation-circle fa-lg" v-show="day.availableRsvp.length > 0"></i>
              </div>
              <div class="op-date">{{ day.date.format('DD') }}</div>
              <div class="op-day">{{ day.date.format('ddd') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-bind:class="{ 'calendar-info': true, show: !serviceLoading }">
      <div class="info-title" v-if="shownInfo !== null"> <!--@click="closeCalendarInfo"-->
        <!-- <i class="fa fa-arrow-left back-icon"></i> -->
        <span>{{ shownInfo.date.format('DD MMMM, dddd') }}</span>
      </div>
      <div class="info-content" v-if="shownInfo !== null">
        <div class="service-type-overview">
          <div class="title">SERVICES SUMMARY</div>
          <table>
            <thead>
              <tr>
                <th>Service Type</th>
                <th>Open Business</th>
                <th>Available Drivers</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="service in servicesSorted" v-if="service.enabled">
                <td>
                  <span class="service-label" :style="{'background': service.color}">
                    [{{ getBrandCode(service.brandId) }}] {{ service.name }}
                  </span>
                </td>
                <td>{{ getOpenCount(service.id) }}</td>
                <td>{{ getAvailableCount(service.id) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- -->
        <div class="shift-gaps">
          <div class="title">DRIVER AVAILABILITY</div>
          <div class="all-covered" v-show="shownInfo.shiftGaps.length <= 0 && shownInfo.workDrivers.length <= 0">
            <i class="fa fa-check-circle"></i>
            <span>No Driver shifts for this day.</span>
          </div>
          <div class="shift-gap" v-show="shownInfo.workDrivers.length <= 0">
            <i class="fa fa-exclamation-circle"></i>
            <span>No available drivers for this day.</span>
          </div>
          <!--div class="shift-gap" v-for="(gap, index) in shownInfo.shiftGaps">
            <i class="fa fa-exclamation-circle"></i>
            <span>No driver coverage from {{ gap.start.format('hh:mmA') }} to {{ gap.end.format('hh:mm A') }}</span>
            <a v-bind:class="{ 'button xsmall': true, disabled: disabledButtons }" href="javascript:;" @click="findCoverageDrivers(gap)">FIND DRIVERS</a>
          </div>-->
          <div class="shift-gap ok" v-for="(driver, index) in shownInfo.workDrivers">
            <i class="fa fa-check-circle"></i>
            <span>Driver</span>
            <a :href="'/#/provider/' + driver.driverId" target="_blank">{{ driver.firstName }} {{ driver.lastName }}</a>
            <span>from</span>
            <span class="time-value" v-if="shownInfo.date.format('MM/DD') !== driver.shiftStart.format('MM/DD')">(-1)</span>
            <span class="time-value">{{ driver.shiftStart.format('hh:mmA') }}</span>
            <span>to</span>
            <span class="time-value">{{ driver.shiftEnd.format('hh:mmA') }}</span>
            <span class="time-value" v-if="shownInfo.date.format('MM/DD') !== driver.shiftEnd.format('MM/DD')">(+1)</span>
          </div>
        </div>
        <div class="unassigned-rsvps">
          <div class="title">RESERVATIONS</div>
          <div class="all-assigned" v-show="shownInfo.availableRsvp.length <= 0 && shownInfo.assignedRsvp.length <= 0">
            <i class="fa fa-check-circle"></i>
            <span>No reservations for this day.</span>
          </div>
          <div class="rsvp" v-for="(rsvp, index) in shownInfo.availableRsvp">
            <i class="fa fa-exclamation-circle"></i>
            <a target="_blank" :href="'/#/package/' + rsvp.packageID" v-if="rsvp.packageID !== null">
              <i class="fas fa-box"></i>
              <span>{{ rsvp.packageID }}</span>
            </a>
            <a target="_blank" :href="'/#/reservation/' + rsvp.rsvpId" v-else>{{ rsvp.rsvpId }}</a>
            <span>pickup at</span>
            <span class="time-value" v-if="rsvp.packageID !== null">{{ rsvp.firstPickup.format('hh:mmA') }}</span>
            <span class="time-value" v-else>{{ rsvp.pickupTime.format('hh:mmA') }}</span>
            <!--span v-bind:class="['service-label', getServiceCode(rsvp.serviceTypeId)]">{{ getServiceLabel(rsvp.serviceTypeId) }}</span-->
            <a v-bind:class="{ 'button xsmall': true, disabled: disabledButtons }" href="javascript:;" @click="findRsvpDrivers(rsvp)">FIND DRIVERS</a>
          </div>
          <div class="rsvp ok" v-for="(rsvp, index) in shownInfo.assignedRsvp">
            <i class="fa fa-check-circle"></i>
            <a target="_blank" :href="'/#/package/' + rsvp.packageID" v-if="rsvp.packageID !== null">
              <i class="fas fa-box"></i>
              <span>{{ rsvp.packageID }}</span>
            </a>
            <a target="_blank" :href="'/#/reservation/' + rsvp.rsvpId" v-else>{{ rsvp.rsvpId }}</a>
            <span>pickup at</span>
            <span class="time-value" v-if="rsvp.packageID !== null">{{ rsvp.firstPickup.format('hh:mmA') }}</span>
            <span class="time-value" v-else>{{ rsvp.pickupTime.format('hh:mmA') }}</span>
            <span>assigned to</span>
            <a target="_blank" :href="'/#/provider/' + rsvp.driverId">{{ rsvp.firstName }} {{ rsvp.lastName }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'

export default {
  name: 'coverage-calendar',
  props: [ 'sector' ],
  data () {
    return {
      months: {},
      shownInfo: null,
      initializingCalendar: true,
      disabledButtons: false,
      servicesSorted: {}
    }
  },
  computed: {
    startDate () { return moment(this.$store.state.coverage.filters.startDate) },
    endDate () { return moment(this.$store.state.coverage.filters.endDate) },
    selectedSector () { return this.$store.state.coverage.filters.selectedSector },
    services () { return this.$store.state.services.list },
    serviceLoading () { return this.$store.state.services.serviceLoading }
  },
  methods: {
    getServiceCode (id) {
      let services = CONFIG.serviceId

      for (let prop in services) {
        if (!services.hasOwnProperty(prop)) {
          return
        }

        if (services[prop] !== id) {
          continue
        }
        return prop
      }
    },
    getServiceLabel (id) {
      let services = CONFIG.serviceId

      for (let prop in services) {
        if (!services.hasOwnProperty(prop)) {
          return
        }

        if (services[prop] !== id) {
          continue
        }

        if (prop === 'shared') {
          return 'Shared Ride'
        } else if (prop === 'opoli') {
          return 'Direct Non-Stop'
        } else if (prop === 'black') {
          return 'Sedan'
        } else if (prop === 'suv') {
          return 'SUV'
        }
        return 'Private Van'
      }
    },
    getOpenCount (id) {
      let self = this
      let result = 0
      for (let i = 0; i < self.shownInfo.availableRsvp.length; i++) {
        let rsvp = self.shownInfo.availableRsvp[i]
        if (rsvp.serviceTypeId === id) {
          result++
        }
      }
      return result
    },
    getAvailableCount (id) {
      let self = this
      let result = 0
      for (let i = 0; i < self.shownInfo.workDrivers.length; i++) {
        let driver = self.shownInfo.workDrivers[i]
        if (driver.services.indexOf(id) >= 0) {
          result++
        }
      }

      return result
    },
    findRsvpDrivers (rsvp) {
      let self = this
      self.disabledButtons = true
      self.$store.commit('coverage/setCoverageMapShowPolygons', false)

      let url = '/admin/rsvp/' + rsvp.rsvpId
      if (rsvp.packageID !== null) {
        url = '/admin/package/' + rsvp.packageID
      }

      self.$sdk.get(url, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.disabledButtons = false
        if (r.error) {
          self.$store.commit('coverage/setCoverageMapRsvp', null)
          return
        }
        if (r.package) {
          r.isPackage = true
          // process stops
          let start = moment(r.package.localPickupTime, 'YYYY-MM-DD HH:mm:ss Z')

          for (let i = 0; i < r.stops.length; i++) {
            let etaStopTime = moment(start).add(r.stops[i].eta, 'seconds')
            r.stops[i]['etaTime'] = etaStopTime
          }
        } else {
          r.isPackage = false
          r.stops = []
        }
        r['serviceTypeId'] = rsvp.serviceTypeId
        self.$store.commit('coverage/setCoverageMapRsvp', r)
        self.$store.commit('coverage/setCoverageMapGap', null)
        self.$store.commit('coverage/setCoverageMapSector', self.sector)
      })
    },
    findCoverageDrivers (gap) {
      let self = this

      self.$store.commit('coverage/setCoverageMapShowPolygons', false)
      self.$store.commit('coverage/setCoverageMapRsvp', null)
      self.$store.commit('coverage/setCoverageMapGap', gap)
      self.$store.commit('coverage/setCoverageMapSector', self.sector)
    },
    initialize () {
      let self = this
      self.sector['workDrivers'] = []
      self.sector['homeDrivers'] = []
      self.sector['homebaseDrivers'] = []
      self.sector['driverDropoff'] = []
      self.sector['assignedRsvp'] = []
      self.sector['availableRsvp'] = []
      self.sector['shiftGaps'] = []

      self.shownInfo = null

      self.getCoverageInfo(self.sector.ID)
      // self.findSectorIssues(self.sector.ID)

      self.sortServicesByPriority()
    },
    sortServicesByPriority() {
      let self = this
      let services = self.services

      function CustomSort(a, b) {
        let service1 = a['brandId'];
        let service2 = b['brandId'];
        if(service1 - service2 !=0){
            return service1 - service2;
        }
        else{
            if (a.priority < b.priority)
              return -1;
            if (a.priority > b.priority)
              return 1;
            return 0;
        }
      }

      self.servicesSorted = services.sort(CustomSort)
    },
    initializeCalendar () {
      let self = this
      let start = moment(self.startDate)
      let end = moment(self.endDate)

      // self.log()

      self.months = {}
      while (end > start || start.format('M') === end.format('M')) {
        self.months[start.format('MMMM YYYY')] = {
          month: start.format('MM'),
          monthName: start.format('MMMM'),
          monthYear: start.format('YYYY'),
          days: []
        }
        start.add(1,'month')
      }

      start = moment(self.startDate)
      end = moment(self.endDate)

      for (let m = moment(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
        let monthKey = m.format('MMMM YYYY')
        let coverage = self.getCoverage(moment(m))
        let dateObject = moment(m)
        if (dateObject.isAfter(end)) {
          continue
        }
        let day = {
          shiftGaps: coverage.shiftGaps,
          workDrivers: coverage.workDrivers,
          homeDrivers: coverage.homeDrivers,
          assignedRsvp: coverage.assignedRsvp,
          availableRsvp: coverage.availableRsvp,
          date: dateObject,
          show: false
        }
        self.months[monthKey].days.push(day)
      }

      for (let key in self.months) {
        if (!self.months.hasOwnProperty(key)) {
          continue
        }
        let month = self.months[key]

        if (month.days.length <= 0) {
          continue
        }

        let itemsToInsert = []

        if (month.days[0].date.format('dddd') === 'Monday') {
          itemsToInsert.push(null)
        } else if (month.days[0].date.format('dddd') === 'Tuesday') {
          itemsToInsert.push(null)
          itemsToInsert.push(null)
        } else if (month.days[0].date.format('dddd') === 'Wednesday') {
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
        } else if (month.days[0].date.format('dddd') === 'Thursday') {
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
        } else if (month.days[0].date.format('dddd') === 'Friday') {
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
        } else if (month.days[0].date.format('dddd') === 'Saturday') {
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
          itemsToInsert.push(null)
        }

        for (let i = 0; i < itemsToInsert.length; i++) {
          self.months[key].days.unshift(itemsToInsert[i])
        }
      }
      self.initializingCalendar = false
      setTimeout(() => {
        self.$store.commit('coverage/addCoverageReportSector', {
          name: self.sector.name,
          id: self.sector.ID,
          data: self.months
        })
      }, 500)
    },
    getCoverageInfo(sectorId) {
      let self = this
      let startMoment = moment(self.$store.state.coverage.filters.startDate)
      let endMoment = moment(self.$store.state.coverage.filters.endDate)

      self.$sdk.get('/sectors/' + sectorId + '/coverage', {
        token: self.$store.state.session.sessionToken,
        start: startMoment.format('YYYY-MM-DD'),
        end: endMoment.format('YYYY-MM-DD')
      }, r => {
        if (r.error) {
          setTimeout(() => {
            self.$store.commit('coverage/setCoverageSectorsIssueState', {
              id: sectorId,
              hasIssues: false,
              shiftGaps: [],
              unassigned: []
            })
          }, 500)
          self.sector.issueState = 'ok'
          self.sector.workDrivers = []
          self.sector.homeDrivers = []
          self.sector.homebaseDrivers = []
          self.sector.driverDropoff = []
          self.sector.assignedRsvp = []
          self.sector.availableRsvp = []
          self.sector.shiftGaps = []
        } else {
          let shiftGaps = self.processShiftGaps(r.shiftGaps)
          setTimeout(() => {
            self.$store.commit('coverage/setCoverageSectorsIssueState', {
              id: sectorId,
              hasIssues: r.rsvpAvailable.length > 0, // (shiftGaps.length > 0 || r.rsvpAvailable.length > 0),
              shiftGaps: shiftGaps,
              unassigned: r.rsvpAvailable
            })
          }, 500)
          self.sector.issueState = r.rsvpAvailable.length > 0 ? 'has-issues' : 'ok'
          // (r.shiftGaps.length > 0 || r.rsvpAvailable.length > 0) ? 'has-issues' : 'ok'
          self.sector.workDrivers = r.driverWork
          self.sector.homeDrivers = r.driverHome
          self.sector.homebaseDrivers = r.profileHome
          self.sector.driverDropoff = r.driverDropoff
          self.sector.assignedRsvp = r.rsvpAssigned
          self.sector.availableRsvp = r.rsvpAvailable
          self.sector.shiftGaps = shiftGaps
        }
        self.initializeCalendar()
      })
    },
    processShiftGaps (gaps) {
      let now = moment().unix()
      let result = []

      for (let i = 0; i < gaps.length; i++) {
        let gap = gaps[i]
        if (gap.end < now) {
          continue
        }

        if (gap.start < now) {
          let start = now
          result.push({
            start: start,
            end: gap.end
          })
          continue
        }

        result.push({
          start: gap.start,
          end: gap.end
        })
      }
      return result
    },
    getCoverage (date) {
      let self = this
      let sector = self.sector
      let result = {
        workDrivers: [],
        homeDrivers: [],
        assignedRsvp: [],
        availableRsvp: [],
        shiftGaps: []
      }
      let dateStr = date.format('MM/DD/YYYY')
      let start = moment(dateStr + ' 00:00:00AM', 'MM/DD/YYYY hh:mm:ssA').unix()
      let end = moment(dateStr + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA').unix()

      // work drivers
      for (let i = 0; i < sector.workDrivers.length; i++) {
        let driver = sector.workDrivers[i]

        if ((driver.shiftStart >= start && driver.shiftStart <= end) ||
            (driver.shiftEnd >= start && driver.shiftEnd <= end)) {
          driver.shiftStart = moment.unix(driver.shiftStart)
          driver.shiftEnd = moment.unix(driver.shiftEnd)
          result.workDrivers.push(driver)
        }
      }

      // home drivers
      for (let i = 0; i < sector.homeDrivers.length; i++) {
        let driver = sector.homeDrivers[i]


        if ((driver.shiftStart >= start && driver.shiftStart <= end) ||
            (driver.shiftEnd >= start && driver.shiftEnd <= end)) {
          driver.shiftStart = moment.unix(driver.shiftStart)
          driver.shiftEnd = moment.unix(driver.shiftEnd)
          result.homeDrivers.push(driver)
        }
      }

      // assigned rsvp
      for (let i = 0; i < sector.assignedRsvp.length; i++) {
        let rsvp = sector.assignedRsvp[i]

        if (rsvp.packageID !== null) {
          if (rsvp.firstPickup >= start && rsvp.firstPickup <= end) {
            rsvp.firstPickup = moment.unix(rsvp.firstPickup)
            rsvp.pickupTime = moment.unix(rsvp.pickupTime)
            result.assignedRsvp.push(rsvp)
          }
        } else {
          if (rsvp.pickupTime >= start && rsvp.pickupTime <= end) {
            rsvp.pickupTime = moment.unix(rsvp.pickupTime)
            result.assignedRsvp.push(rsvp)
          }
        }
      }

      // available rsvp
      for (let i = 0; i < sector.availableRsvp.length; i++) {
        let rsvp = sector.availableRsvp[i]

        if (rsvp.packageID !== null) {
          if (rsvp.firstPickup >= start && rsvp.firstPickup <= end) {
            rsvp.firstPickup = moment.unix(rsvp.firstPickup)
            rsvp.pickupTime = moment.unix(rsvp.pickupTime)
            result.availableRsvp.push(rsvp)
          }
        } else {
          if (rsvp.pickupTime >= start && rsvp.pickupTime <= end) {
            rsvp.pickupTime = moment.unix(rsvp.pickupTime)
            result.availableRsvp.push(rsvp)
          }
        }
      }

      // shift gaps
      let log = false
      if (dateStr === '05/16/2019' && sector.ID === 10) {
        // console.log('LOG')
        log = false
      }
      for (let i = 0; i < sector.shiftGaps.length; i++) {
        let startGap = sector.shiftGaps[i].start
        let endGap = sector.shiftGaps[i].end

        if (start > endGap || end < startGap) {
          continue
        }

        if (log) {
          console.log('GAP: ' + moment.unix(startGap).format('MM/DD hh:mm:ss A') + ' - ' + moment.unix(endGap).format('MM/DD hh:mm:ss A'))
        }
        // if startGap and endGap falls within the day...
        if (startGap >= start && startGap <= end && endGap >= start && endGap <= end) {
          result.shiftGaps.push({
            start: moment.unix(startGap),
            end: moment.unix(endGap)
          })
          if (log) {
            console.log('1: ' + moment.unix(startGap).format('hh:mmA') + ' - ' + moment.unix(endGap).format('hh:mmA'))
          }
        } else if (start >= startGap && start <= endGap && end >= startGap && end <= endGap ) { // entire day falls within the gap
          result.shiftGaps.push({
            start: moment.unix(start),
            end: moment.unix(end)
          })
          if (log) {
            console.log('2: ' + moment.unix(start).format('hh:mmA') + ' - ' + moment.unix(end).format('hh:mmA'))
          }
        } else if (start >= startGap && start < endGap) {
          result.shiftGaps.push({
            start: moment.unix(start),
            end: moment.unix(endGap)
          })
          if (log) {
            console.log('3: ' + moment.unix(start).format('hh:mmA') + ' - ' + moment.unix(endGap).format('hh:mmA'))
          }
        } else if (end >= startGap && end <= endGap) {
          result.shiftGaps.push({
            start: moment.unix(startGap),
            end: moment.unix(end)
          })
          if (log) {
            console.log('4: ' + moment.unix(startGap).format('hh:mmA') + ' - ' + moment.unix(end).format('hh:mmA'))
          }
        }
      }
      return result
    },
    closeCalendarInfo () {
      this.shownInfo = null
      this.$store.commit('coverage/setCoverageMapShowPolygons', true)
      this.$store.commit('coverage/resetCoverageSectorBodyHeight', {
        id: this.sector.ID,
        bodyHeight: 'auto'
      })
    },
    showCalendarInfo (day) {
      if (day.availableRsvp.length <= 0 && day.shiftGaps.length <= 0) {
        // return
      }
      this.shownInfo = day
      let multiplier = 0
      // multiplier += day.shiftGaps.length
      if (day.workDrivers.length <= 0) {
        multiplier += 1
      }
      multiplier += day.availableRsvp.length
      multiplier += day.workDrivers.length
      multiplier += day.assignedRsvp.length
      if (day.availableRsvp.length <= 0 && day.assignedRsvp.length <= 0) {
        multiplier += 1
      }
      if (day.shiftGaps.length <= 0 && day.workDrivers.length <= 0) {
        multiplier += 1
      }
      this.$store.commit('coverage/resetCoverageSectorBodyHeight', {
        id: this.sector.ID,
        bodyHeight: (300 + 114 + (52.66 * multiplier)) + 'px'
      })
    },
    log () {
      let self = this
      let format = 'MM/DD/YYYY hh:mm:ssA'
      let sector = self.sector
      let shiftGaps = sector.shiftGaps
      console.log(sector.name, sector)

      // log shiftGaps
      console.log('- shift_gaps', shiftGaps)
      for (let i = 0; i < sector.shiftGaps.length; i++) {
        let start = moment.unix(sector.shiftGaps[i].start)
        let end = moment.unix(sector.shiftGaps[i].end)
        console.log('-- ' + start.format(format) + ' - ' + end.format(format))
      }
      console.log('- shift_gaps', sector.shiftGaps.length)

      // log rsvp available
      console.log('- rsvp available', sector.availableRsvp)
      for (let i = 0; i < sector.availableRsvp.length; i++) {
        console.log('-- ', sector.availableRsvp[i])
      }
      console.log('- rsvp available', sector.availableRsvp.length)
    },
    getBrandCode (id) {
      let index = CONFIG.brands.findIndex(x => x.id === id)
      if (index === -1) { return ''}

      return CONFIG.brands[index].code.toUpperCase()
    },
    triggerShowCalendarInfo () {
      let monthData = this.months[Object.keys(this.months)[0]]
      let daysData = ''
      for (let index in monthData['days']) {
        if (monthData['days'][index]) {
          this.showCalendarInfo(monthData['days'][index])
          return
        }
      }
    }
  },
  watch: {
    startDate (value) {
      this.initialize()
    },
    endDate (value) {
      // this.initialize()
    },
    selectedSector (value) {
      if (value === -1) {
        return
      }
      this.initialize()
    }
  },
  mounted () {
    let self = this
    setTimeout(() => {
      self.initialize()
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.coverage-calendar {
  position: relative;
}

.calendar-loader {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 20px;
  color: #555;

  & .title { margin-top: 5px; }
}

.calendar-info {
  position: absolute;
  top: 0;
  left: calc(100% + 10px);
  width: 100%;
  // height: calc(100% + 30px);
  background-color: #fff;
  transition: all 250ms;
  box-shadow: -2px 0 4px rgba(0,0,0,0.3);

  &.show {
    left: 0;
  }

  & .info-title {
    position: relative;
    text-align: center;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
    color: #777;
    padding: 15px;
    background-color: #fff;
    border-bottom: 1px solid rgba(0,0,0,0.15);
    cursor: pointer;
    transition: all 250ms;
    &:hover { background-color: #f9f9f9; }

    & .back-icon {
      position: absolute;
      top: 15px;
      left: 15px;
    }
  }
}

.service-type-overview {
  padding: 15px 15px 15px;
  max-height: 200px;
  overflow-y: auto;
  border-bottom: 1px solid rgba(0,0,0,0.15);

  & .title {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  table {
    margin-top: 15px;
    border-collapse: collapse;
    width: 100%;
    text-align: center;


    & thead{
      color: #8DA0A9;
      font-size: 12px;
      border: 1px solid rgba(0,0,0,0.3);
      background-color: #f5f5f5;

      & th{
        padding: 5px 10px;
      }
    }

    & tbody {
      & tr {
        background-color: #fff;
        border: 1px solid rgba(0,0,0,0.3);
        position: relative;

        & td{
          padding: 10px;
          text-align: center;
          font-size: 12px;
          margin-bottom: 5px;
        }
      }
    }
  }

}
.shift-gaps {
  padding: 0 15px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  height: 140px;
  overflow: auto;

  & .title {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    margin-top: 15px;
  }

  & .all-covered {
    margin: 15px 0;
    color: #26D97A;
    font-weight: 700;
    & > * {
      display: inline-block;
      vertical-align: middle;
    }
  }

  & .shift-gap {
    position: relative;
    font-weight: 700;
    color: #F25E0D;
    padding: 15px 0;
    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & > .button {
      position: absolute;
      top: 13px;
      right: 0;
    }

    &.ok { color: #26D97A; }

    & .time-value { color: #0D79F2; }
  }
}

.unassigned-rsvps {
  padding: 0 15px;
  height: 140px;
  overflow: auto;
  border-bottom: 1px solid rgba(0,0,0,0.15);

  & .title {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    margin-top: 15px;
  }

  & .all-assigned {
    margin: 15px 0;
    color: #26D97A;
    font-weight: 700;
    & > * {
      display: inline-block;
      vertical-align: middle;
    }
  }

  & .rsvp {
    position: relative;
    font-weight: 700;
    color: #F25E0D;
    padding: 15px 0;
    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & > .button {
      position: absolute;
      top: 13px;
      right: 0;
    }

    &.ok { color: #26D97A; }

    & .time-value { color: #0D79F2; }
  }
}
.calendar-days {
  padding: 0 13px;
}
.op-calendar {
  display: block;
  width: 100%;
  margin: 15px 0;

  & .op-calendar-title {
    text-align: center;
    font-weight: 700;
    color: #0D79F2;
    text-transform: uppercase;
  }

  & .op-calendar-days {
    display: block;
    width: 100%;
    margin-top: 15px;
  }

  & .op-calendar-day {
    width: calc(100%/7);
    display: inline-block;
    border: 1px solid rgba(0,0,0,0.15);
    border-right: 0;
    background-color: #fff;
    cursor: pointer;
    transition: all 250ms;

    &:nth-child(7n+7),
    &:last-child{ border-right: 1px solid rgba(0,0,0,0.15); }

    &:hover { background-color: #f5f5f5; }

    &.no-border{ border: 0; }

    & .op-date {
      color: #0D79F2;
      font-size: 24px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      margin-bottom: 5px;
    }

    & .op-day {
      color: #555;
      text-align: center;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 10px;
    }

    & .op-icon {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 5px;

      & .fa-check-circle { color: #26D97A; }
      & .fa-exclamation-circle { color: #F25E0D; }
    }
  }
}
.service-label{
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
  margin-top: 2px;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}
</style>



// WEBPACK FOOTER //
// src/components/Coverage/Calendar.vue